import { runDemo } from "../shared/demoRunner";
import { createHighlightsScene } from "./scene";

runDemo({ createScene: createHighlightsScene });
